import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import { Button, Row, Col } from 'reactstrap';
import { faCamera, faFileSignature, faFilter, faEraser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Helpers
import { showMessage } from '../../../helpers/message';
import { objCampo, validarCampos } from '../../../helpers/ValidadorDeCampos';
import { formatDataHora } from '../../../helpers/formatDataHora';

//Componentes
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import ExecucaoFiscalizacaoStepper from './components/ExecucaoFiscalizacaoStepper';
import ModalCustomized from '../../../components/Modal/Modal';
import TextField from '../../../components/TextField';

//Context
import { useAuth } from '../../../context/auth';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Api
import solicitacaoFiscalizacao_api from '../../../api/solicitacaoFiscalizacao_api';
import solicitacaoFiscalizacaoFinalizada_api from '../../../api/solicitacaoFiscalizacaoFinalizada_api';
import tipoDeFiscalizacao_api from '../../../api/tipoDeFIscalizacao_api';

//Prefixo da chave usada para repassar os dados da solicitação para a guia aberta ao executar a fiscalização
const CHAVE_SESSAO_EXECUCAO = 'execucaoFiscalizacao_pendente_';

function initialStateFinalizacaoSemFiscalizacao(idSolicitacao = "") {
    return {
        justificativa: "",
        arquivo: "",
        dataHora: "",
        solicitacaoFiscalizacao_Id: idSolicitacao,
    }
}

function initialStateFiltros() {
    return {
        tipoFiscalizacao_Id: "",
        dataInicial: "",
        dataFinal: "",
        logradouro: "",
        numero: "",
        bairro: "",
        nomeDenunciante: "",
    }
}

//Converte os filtros do formulário (strings vazias) para o formato aceito pela API (null quando não preenchido)
function construirFiltroBusca(filtros) {
    return {
        tipoFiscalizacao_Id: filtros.tipoFiscalizacao_Id || null,
        dataInicial: filtros.dataInicial || null,
        dataFinal: filtros.dataFinal || null,
        logradouro: filtros.logradouro || null,
        numero: filtros.numero || null,
        bairro: filtros.bairro || null,
        nomeDenunciante: filtros.nomeDenunciante || null,
    }
}
function ExecucaoDeFiscalizacao() {
    const { setLoading } = useAuth();

    //Referencia para o campo de arquivo da finalização
    const refFileFinalizacao = useRef();

    //Estado de controle de visibilidade do modal
    const [visibleModal, setVisibleModal] = useState(false);
    const toggleModal = () => {
        setVisibleModal(!visibleModal)
        setErrors({});
    };

    //Estado de controle da lista de solicitações
    const [listaSolicitacoes, setListaSolicitacoes] = useState([]);

    //Estado de controle do id da solicitação a ser fiscalizada
    const [solicitacaoFiscalizacao, setSolicitacaoFiscalizacao] = useState(null);

    //Estado que guarda a ação que será executada
    const [acao, setAcao] = useState("Fiscalizar");

    //Estado de controle da fiscalização avulsa
    const [fiscalizacaoAvulsa, setFiscalizacaoAvulsa] = useState(false);

    //Estado que guarda o objeto de envio dos dados da finalização
    const [finalizacao, setFinalizacao] = useState(initialStateFinalizacaoSemFiscalizacao());

    //Estado de controle de errors na finalizacao
    const [errors, setErrors] = useState({});

    //Estado de controle dos filtros da lista
    const [filtros, setFiltros] = useState(initialStateFiltros());

    //Estado que guarda as opções de tipo de fiscalização exibidas no filtro
    const [listaTiposFiscalizacao, setListaTiposFiscalizacao] = useState([]);

    //campos obrigatorios da finalizacao
    const camposFinalizacao = [
        objCampo({ name: "justificativa", required: "true" })
    ]

    //onChange dos campos da finalizacao
    const onChange = (e) => {
        const { name, value } = e.target;
        setFinalizacao({
            ...finalizacao,
            [name]: value
        });
    }

    //Cabeçalhos da lista de consulta infração
    const headers = [
        { value: "Tipo de Fiscalização", objectValue: "tipoFiscalizacao_Descricao", align: "left" },
        { value: "Data do Flagrante", objectValue: "dataFlagrandeFormatada", align: "left" },
        { value: "Nome Fiscal", objectValue: "nomeFiscal", align: "left" },
        { value: "Endereço", objectValue: "enderecoCompleto", align: "left" },
        { value: "Origem", objectValue: "origem", align: "left" },
        { value: "Prazo de execução", objectValue: "dataLimiteExecucaoFormatada", align: "left" },
        { value: "Subprefeitura", objectValue: "regional", align: "left" }
    ];

    //onChange dos campos de texto/data do filtro
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros(prev => ({ ...prev, [name]: value }));
    };

    //onChange do select de tipo de fiscalização do filtro
    const onChangeTipoFiscalizacaoFiltro = (value) => {
        setFiltros(prev => ({ ...prev, tipoFiscalizacao_Id: value ? value.value : "" }));
    };

    //Função que carrega os tipos de fiscalização exibidos no select do filtro
    const loadTiposFiscalizacao = () => {
        tipoDeFiscalizacao_api.getListAtivos()
            .then(response => {
                setListaTiposFiscalizacao(response.data.map(value => ({
                    value: value.id,
                    label: value.identificacao,
                })));
            })
            .catch(ex => showMessage('Aviso!', ex.message, "error", null));
    };

    //Função que carrega a lista de solicitações pendentes
    const loadSolicitacoes = (filtrosBusca = filtros) => {
        setLoading(true);
        solicitacaoFiscalizacao_api.getListPendentes(construirFiltroBusca(filtrosBusca)).then(response => {
            response.data = response.data.map(value => {
                value.dataFlagrandeFormatada = formatDataHora(value.dataFlagrande) || "Sem data";
                value.dataLimiteExecucaoFormatada = value.dataLimiteExecucao ? moment(value.dataLimiteExecucao).format("DD/MM/YYYY") : "";
                return value;
            })
            setListaSolicitacoes(response.data);
        }).catch(ex => showMessage('Aviso!', ex.message, "error", null))
            .finally(f => setLoading(false));
    };

    //Função que aplica os filtros preenchidos na busca da lista
    const handleFiltrar = () => loadSolicitacoes(filtros);

    //Função que limpa os filtros e recarrega a lista completa
    const handleLimparFiltros = () => {
        const _filtros = initialStateFiltros();
        setFiltros(_filtros);
        loadSolicitacoes(_filtros);
    };

    //Abre a execução de uma solicitação em outra guia, repassando os dados já carregados na lista atual
    const abrirExecucaoEmNovaGuia = (solicitacao) => {
        sessionStorage.setItem(CHAVE_SESSAO_EXECUCAO + solicitacao.id, JSON.stringify(solicitacao));
        const url = `${window.location.origin}${window.location.pathname}?executarId=${solicitacao.id}`;
        window.open(url, '_blank');
    };

    //Função que verifica se a solicitação já foi executada antes de abrir a fiscalização em outra guia
    const realizarFiscalizacao = (solicitacao) => {
        setLoading(true);
        solicitacaoFiscalizacao_api.verificarExecucao(solicitacao.id).then(response => {
            if (response.data?.jaExecutada) {
                showMessage('Aviso!', 'Esta fiscalização já foi executada e não pode ser executada novamente.', 'warning', null);
                return;
            }
            abrirExecucaoEmNovaGuia(solicitacao);
        }).catch(ex => showMessage('Aviso!', ex.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função que salva os dados da solicitação para a finalização
    const realizarFinalizacao = (solicitacao) => {
        setFinalizacao(initialStateFinalizacaoSemFiscalizacao(solicitacao.id));
        setSolicitacaoFiscalizacao(solicitacao);
        setAcao("Finalizar");
        toggleModal();
    }

    //Função responsavel por pelo clique no botão de tirar foto
    const onClickSalvarFoto = () => {
        refFileFinalizacao.current.click();
    };

    //Função de onChange do arquivo
    const handleFileChange = (e) => {
        const FR = new FileReader();
        FR.addEventListener("load", function (evt) {
            const extensao = evt.target.result.split("/")[1].split(";")[0];
            if (extensao != "png" && extensao != "jpg" && extensao != "jpeg") {
                showMessage("Aviso!", "Apenas arquivos com extensão do tipo imagem são aceitos", "warning", null);
                return;
            }
            const _finalizacao = {
                ...finalizacao,
                arquivo: evt.target.result.split("base64,")[1],
            };
            setFinalizacao(_finalizacao);
        });
        if (e.target.files)
            FR.readAsDataURL(e.target.files[0]);
    };

    //Função que envia os dados da finalização para a api
    const onSubmitFinalizacao = () => {
        const _errors = validarCampos(finalizacao, camposFinalizacao);
        setErrors(_errors[0]);
        if (_errors[1].length > 0)
            return;

        const _sincronizacao = {
            ...finalizacao
        }
        _sincronizacao.dataHora = moment().format();
        setLoading(true);
        solicitacaoFiscalizacaoFinalizada_api.post(_sincronizacao).then(async response => {
            showMessage("Sucesso!", "Solicitação finalizada com sucesso!", "success", null);
            loadSolicitacoes();
            toggleModal();
        }).catch(e => {
            showMessage("Aviso", e.message, "error", true);
        })
            .finally(f => setLoading(false));
    }

    //Variavel que guarda as ações da tabela
    const actions = [actionsTable.encerrarSemAuto(realizarFinalizacao), actionsTable.dinamico(faFileSignature, realizarFiscalizacao, "Executar Fiscalização")];

    const handleVoltar = () => {
        setSolicitacaoFiscalizacao(null);
        setFiscalizacaoAvulsa(false);
        loadSolicitacoes();
    }

    //Ao montar, verifica se a guia foi aberta a partir do clique em "Executar Fiscalização" em outra guia
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const executarId = params.get('executarId');

        if (executarId) {
            const chave = CHAVE_SESSAO_EXECUCAO + executarId;
            const dadosSalvos = sessionStorage.getItem(chave);
            window.history.replaceState({}, '', window.location.pathname);

            //Carrega o select de tipo de fiscalização já aqui, para que ele não fique vazio
            //quando o fiscal voltar da execução para esta guia
            loadTiposFiscalizacao();

            if (dadosSalvos) {
                sessionStorage.removeItem(chave);
                setSolicitacaoFiscalizacao(JSON.parse(dadosSalvos));
                setAcao("Fiscalizar");
                return;
            }

            //Fallback quando os dados não estão no sessionStorage (link copiado, "noopener" ou sessão restaurada)
            setLoading(true);
            solicitacaoFiscalizacao_api.getItem(executarId).then(response => {
                setSolicitacaoFiscalizacao({
                    ...response.data,
                    tipoFiscalizacao_Id: response.data.tipoFiscalizacao_id,
                });
                setAcao("Fiscalizar");
            }).catch(ex => {
                showMessage('Aviso!', ex.message, "error", null);
                loadSolicitacoes(initialStateFiltros());
            }).finally(f => setLoading(false));
            return;
        }

        loadTiposFiscalizacao();
        loadSolicitacoes(initialStateFiltros());
    }, []);

    if ((solicitacaoFiscalizacao && acao == "Fiscalizar") || fiscalizacaoAvulsa) {
        return <ExecucaoFiscalizacaoStepper
            solicitacaoFiscalizacao={solicitacaoFiscalizacao}
            handleVoltar={handleVoltar}
            avulso={fiscalizacaoAvulsa}
        />
    }

    return <>
        <ModalCustomized title={"Finalizar solicitação sem fiscalização"} isOpen={visibleModal} toggle={toggleModal} btnClose>
            <Row>
                <Col md="12">
                    <TextField
                        name="justificativa"
                        label={"Observações"}
                        value={finalizacao.justificativa}
                        onChange={onChange}
                        type={'textarea'}
                        invalid={!!errors.justificativa}
                    />
                </Col>
                <Col md="12">
                    <Button onClick={onClickSalvarFoto} className='w-100' color={finalizacao.arquivo ? "warning text-white" : "primary"}><FontAwesomeIcon icon={faCamera} /> Enviar Imagem</Button>
                </Col>
                <Col md="12">
                    <Button className='w-100 mt-3' color={"success"} onClick={onSubmitFinalizacao}>Salvar finalização</Button>
                </Col>
                <input
                    type="file"
                    ref={refFileFinalizacao}
                    onChange={(e) => handleFileChange(e)}
                    style={{ display: "none" }}
                />
            </Row>
        </ModalCustomized>
        <div className='d-flex align-items-center justify-content-between mb-3'>
            <h4 className='text-secondary m-0'>Execução de fiscalização</h4>
            <Button color='success' onClick={() => setFiscalizacaoAvulsa(true)}>Fiscalização avulsa</Button>
        </div>

        <Row className='mt-3 formContainer'>
            <Col md="12" lg="4">
                <TextField
                    type="select"
                    name="tipoFiscalizacao_Id"
                    label="Tipo de Fiscalização"
                    searchable
                    options={listaTiposFiscalizacao}
                    onChange={onChangeTipoFiscalizacaoFiltro}
                    value={listaTiposFiscalizacao.filter(value => value.value == filtros.tipoFiscalizacao_Id)}
                    placeholder="TODOS"
                />
            </Col>
            <Col md="6" lg="4">
                <TextField type="date" name="dataInicial" label="Data Inicial" onChange={onChangeFiltros} value={filtros.dataInicial} />
            </Col>
            <Col md="6" lg="4">
                <TextField type="date" name="dataFinal" label="Data Final" onChange={onChangeFiltros} value={filtros.dataFinal} />
            </Col>
            <Col md="4" lg="3">
                <TextField type="text" name="logradouro" label="Logradouro" onChange={onChangeFiltros} value={filtros.logradouro} />
            </Col>
            <Col md="4" lg="2">
                <TextField type="text" name="numero" label="Número" onChange={onChangeFiltros} value={filtros.numero} />
            </Col>
            <Col md="4" lg="3">
                <TextField type="text" name="bairro" label="Bairro" onChange={onChangeFiltros} value={filtros.bairro} />
            </Col>
            <Col md="12" lg="4">
                <TextField type="text" name="nomeDenunciante" label="Nome Fiscal" onChange={onChangeFiltros} value={filtros.nomeDenunciante} />
            </Col>
            <Col md="12" lg="12" className='d-flex align-items-center justify-content-center'>
                <Button color='primary' className='mb-2 ms-3 px-4' onClick={handleFiltrar}>
                    <FontAwesomeIcon icon={faFilter} /> Filtrar
                </Button>
                <Button color='secondary' className='mb-2 ms-3 px-4' onClick={handleLimparFiltros}>
                    <FontAwesomeIcon icon={faEraser} /> Limpar
                </Button>
            </Col>
        </Row>

        <TabelaListagem
            actions={actions}
            title={"Lista de fiscalizações"}
            options={{ print: false, search: true, pagination: true }}
            headers={headers}
            items={listaSolicitacoes}
        />
    </>;
}

export default ExecucaoDeFiscalizacao;